import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import loggerApi from '../../../services/apiServices/loggerApi';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../services/redux/loadingSlice';
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import './LogPage.css';

const LogPage = () => {
    const { code } = useParams();
    const dispatch = useDispatch();
    const [log, setLog] = useState(null);

    useEffect(() => {
        const fetchLog = async () => {
            dispatch(setLoading(true));
            try {
                const result = await loggerApi.getLoggerById(code);
                setLog(result);
            } catch (error) {
                toast.error('Erro ao buscar log.');
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchLog();
    }, [code, dispatch]);

    if (!log) return <div className="log-container">Carregando...</div>;

    let parsedText = null;
    try {
        parsedText = JSON.parse(log.TextLog);
    } catch (e) {
        parsedText = { raw: log.TextLog };
    }

    return (
        <div className="container-admin-page">
            <h1>Detalhes do Log</h1>

            <div className="box space-double-bottom">
                <div className="info-group">
                    <p><strong>Id:</strong> {log.Id}</p>
                    <p><strong>Pedido:</strong> {log.OrderId ?? 'Não vinculado'}</p>
                    <p><strong>Data de Criação:</strong> {putDateOnPattern(log.Created)}</p>
                    <p><strong>Última Atualização:</strong> {putDateOnPattern(log.Updated)}</p>
                </div>
            </div>

            <div className="box space-double-bottom">
                <h2>Conteúdo</h2>
                <pre className="log-pre">
                    {JSON.stringify(parsedText, null, 2)}
                </pre>
            </div>
        </div>
    );
};

export default LogPage;
